/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconExternalLink/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconExternalLink({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconExternalLink",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#7D8793"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconExternalLink.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-22cALR': alignSelf,'--mt-2-22cALR': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-22cALR': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-22cALR': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-22cALR': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-22cALR': opacity,'--w-10-22cALR': typeof width === 'number' ? `${width}px` : width,'--h-11-22cALR': typeof height === 'number' ? `${height}px` : height,'--f-12-22cALR': fill,'--a-7-22cALR': isAnimated ? animation : "none",'--sd-8-22cALR': isAnimated ? strokeDashoffset : 0,'--sd-9-22cALR': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconExternalLink.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_6331_7418)"
 className="views-block"
>
<path
  data-testid="TysiaIconExternalLink.SvgPath"
  data-view-path={viewPath}
 d="M12.5 10v4.5a1 1 0 01-1 1h-8a1 1 0 01-1-1v-8a1 1 0 011-1H8M12 2.5h3.5V6M15.5 2.5L10 8"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-22cALR': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}